// extracted by mini-css-extract-plugin
export default {"wrapper":"ppmaS4"};